import { FC, Fragment } from "react";
import { Box, Stack } from "@mui/material";
import { useHover } from "@/utils/hooks/useHover.hook";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { Protection } from "@/components/pages/live-usage-mgmt/components/resource-card/resource-card-content/resource-card-data/resource-card-grid/resouce-card-data-grid/cells/actions-menu-cell-v2/Protection";
import { CopyIconButton } from "@/components/common/CopyIconButton";

interface ResourceGridCleanDialogGridIdentifierCellRendererProps {
  name: string;
  lockIconMessage?: string;
}

export const ResourceGridCleanDialogGridIdentifierCellRenderer: FC<
  ResourceGridCleanDialogGridIdentifierCellRendererProps
> = ({ name, lockIconMessage }) => {
  const { ref, hovered } = useHover();

  if (!name) {
    return <Fragment>[ No Value ]</Fragment>;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      ref={ref}
    >
      <Stack
        direction="row"
        overflow="hidden"
        alignItems="center"
        spacing={0.5}
      >
        <TypographyWithTooltip
          title={name}
          fontSize="inherit"
          sx={{ py: 0.75 }}
        />

        {lockIconMessage && (
          <Protection protectedBy={lockIconMessage} placement="right" />
        )}
      </Stack>

      <Box
        sx={{
          display: hovered ? "flex" : "none",
          visibility: hovered ? "visible" : "hidden",
        }}
      >
        <CopyIconButton data={name} visible={hovered} sx={{ ml: 0.5 }} />
      </Box>
    </Stack>
  );
};
